module.exports = __webpack_public_path__ + "static/img/preview.8336436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview.jpg
// module id = nnr2
// module chunks = 1